import ApiService from '../apiservice'

class UserService extends ApiService {
    constructor() {
        super('');
    }

    login(credentials) {
        return this.post('/login', credentials);
    }
}

export default UserService;